import FooterNav from '@/views/components/footerNav.vue';
export default {
  components: {
    FooterNav
  },
  data() {
    return {
      activeIndex: 0,
      // 底部导航激活下标
      mainName: '',
      // 内容区域动画名
      navName: '',
      // 导航动画名
      isShowNav: false,
      // 是否显示底部导航 Tab
      navTabs: ['Home', 'User'] // 底部导航
    };
  },
  watch: {
    $route(to, from) {
      const {
        navTabs
      } = this.$data;
      const toName = to.name;
      const fromName = from.name;

      //如果是在 navTab 页面内，则显示导航栏
      this.isShowNav = navTabs.includes(toName);
      switch (toName) {
        case 'Home':
          this.activeIndex = 0;
          break;
        case 'User':
          this.activeIndex = 1;
          break;
      }
      /* 判断footer-nav是否显示
       * 根据meta.index判断页面向左滑动 or 向右滑动
      */
      // 判断是否是底部导航之间相互切换
      if (navTabs.includes(toName) && navTabs.includes(fromName)) {
        this.mainName = 'fade';
        this.isShowNav = true;
        // 如果 to 索引大于 from 索引, 判断为前进状态, 反之则为后退状态
      } else if (to.meta.index > from.meta.index) {
        this.mainName = 'slide-left';
        this.navName = 'nav-slide';
      } else if (to.meta.index < from.meta.index) {
        this.mainName = 'slide-right';
        this.navName = 'nav-slide';
        navTabs.includes(toName) && (this.isShowNav = true);
      }
    }
  },
  mounted() {
    // 刷新时清空返回缓存
    window.addEventListener('unload', () => {
      this.$router.options.routes.forEach(item => {
        if (item.meta) item.meta.iback = false;
      });
    });
  }
};